<template>
  <div :class="{ 'invalid': !isValid, 'valid': isValid}">
    <div v-if="!isValid" class="error">{{ errorDescription }}</div>
    <div class="dynamic-inputs">
      <div class="value-list" ref="scrollable">
        <div 
          class="value-group group-w-button"
          v-for="(val, index) in newValues" 
          :key="index"
        >
          <BaseIcon :name="getIcon(val.valtype)" class="icon icon-value"/>
          <input autocomplete="off" type="text" :name="`newValues[${index}][name]`" v-model="val.name" placeholder="Search" @input="updateValues(index)"/>
          <input autocomplete="off" type="text" :name="`newValues[${index}][id]`" v-model="val.id" style="display:none;" /> 
          <BaseIcon name="times-circle" class="icon ico-delete" :class="{'delete-disabled': newValues.length == 1}" @click.native="removeValue(index)"/>
        </div>
        <div class="add-step-button" @click="addNewValue">
          <BaseIcon name="plus-circle" class="icon" />
          <label>Add value</label>  
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BaseIcon from "@/components/base/Icon";
  import InputDash from "@/components/base/InputDash";
  import VerticalStepBullets from "@/components/base/VerticalStepBullets";
  import AutocompleteList from "@/components/base/AutocompleteList";
  import draggable from 'vuedraggable'

  export default {
    components: {
      BaseIcon, 
      InputDash,
      draggable,
      VerticalStepBullets,
      AutocompleteList
    },
    props: {
      label: String,
      name: String,
      value: String,
      filledValues: Array,
      isTextArea: Boolean,
      isDisabled: Boolean,
      placeholder: String,
    },
    data() {
      return {
        stepsResult:[],
        newValues: [],
        isValid: true,
        errorDescription: 'Test can not be empty',
        named_icons: {
          Text: { prefix: "fa", name: "font" }
        },
        possible_icons: [
          { icon: "Text", prefix: "fa", name: "font" }
        ]
      }
    }, 
    mounted() {
      if(this.filledValues.length == 0 || this.filledValues == undefined) {
        this.newValues = [
          {
            id: '',
            name: ''
          },
          {
            id: '',
            name: ''
          }
        ]
      } else {
        this.newValues = this.filledValues
      }
    },
    methods: {
      addNewValue() {
        this.newValues.push({
          id: '',
          name: ''
        })
      },
      scrollToEnd() {
        var container = this.$refs.scrollable
        container.scrollTop = container.scrollHeight + 84;
      },
      changeValueType(index) {
        var pos = this.possible_icons.findIndex(i => i.icon === this.newValues[index].valtype);
        pos += 1
        if(pos == 4) {
          pos = 0
        }
        this.newValues[index].valtype = this.possible_icons[pos].icon
      },
      getIcon() {
        return ["fa", "font"];
      },
      updateValues(index) {
        this.$emit('updateValues', this.newValues)
        this.scrollToEnd()
      },
      removeValue(index) {
        if (this.newValues.length > 1) {
          this.newValues.splice(index, 1);
        }
      },
      sumbitForm() {
        const data = {
          newValues: this.newValues
        }
        alert(JSON.stringify(data, null, 2))
      }
    },
  }
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/inputs";
@import "@/style/components/dynamicStepsList";

::placeholder{
  color: #EFEFEF;
}

.sub-title {
  display: block;
  font-weight: 600;
  color: #035362;
  margin-bottom: 6px;
}

.icon .icon-value {
    cursor: default;
}
</style>
